import { Input } from "@/shared/ui/input";
import { Label } from "@/shared/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/shared/ui/card";
import { User } from "lucide-react";
import type { SignupFormData } from "./types";

interface Step1Props {
  formData: SignupFormData;
  onChange: (field: keyof SignupFormData, value: string) => void;
}

export function Step1PersonalInfo({ formData, onChange }: Step1Props) {
  const passwordMismatch =
    formData.confirmPassword && formData.password !== formData.confirmPassword;

  return (
    <Card className="border-border bg-gradient-accent">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-foreground">
          <User className="h-5 w-5 text-primary" />
          Personal Information
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label htmlFor="firstName" className="text-foreground">First Name</Label>
            <Input
              id="firstName"
              value={formData.firstName}
              onChange={(e) => onChange("firstName", e.target.value)}
              className="bg-background border-border text-foreground"
              placeholder="Enter your first name"
            />
          </div>
          <div>
            <Label htmlFor="lastName" className="text-foreground">Last Name</Label>
            <Input
              id="lastName"
              value={formData.lastName}
              onChange={(e) => onChange("lastName", e.target.value)}
              className="bg-background border-border text-foreground"
              placeholder="Enter your last name"
            />
          </div>
        </div>

        <div>
          <Label htmlFor="email" className="text-foreground">Email Address</Label>
          <Input
            id="email"
            type="email"
            value={formData.email}
            onChange={(e) => onChange("email", e.target.value)}
            className="bg-background border-border text-foreground"
            placeholder="Enter your email address"
          />
        </div>

        <div>
          <Label htmlFor="password" className="text-foreground">Password</Label>
          <Input
            id="password"
            type="password"
            value={formData.password}
            onChange={(e) => onChange("password", e.target.value)}
            className="bg-background border-border text-foreground"
            placeholder="Create a secure password"
          />
        </div>

        <div>
          <Label htmlFor="confirmPassword" className="text-foreground">Confirm Password</Label>
          <Input
            id="confirmPassword"
            type="password"
            value={formData.confirmPassword}
            onChange={(e) => onChange("confirmPassword", e.target.value)}
            className={`bg-background border-border text-foreground ${
              passwordMismatch ? "border-destructive" : ""
            }`}
            placeholder="Confirm your password"
          />
          {passwordMismatch && (
            <p className="text-sm text-destructive mt-1">Passwords do not match</p>
          )}
        </div>

        <div>
          <Label htmlFor="phoneNumber" className="text-foreground">Phone Number</Label>
          <Input
            id="phoneNumber"
            type="tel"
            value={formData.phoneNumber}
            onChange={(e) => onChange("phoneNumber", e.target.value)}
            className="bg-background border-border text-foreground"
            placeholder="Enter your phone number"
          />
        </div>
      </CardContent>
    </Card>
  );
}
